import React from "react";
import { connect } from "react-redux";

import history from "../../history";
import { setError } from "../../actions/errorActions";

import "./ErrorScreen.css";

class ErrorScreen extends React.Component {
    componentDidMount() {
        this.backListener = history.listen(() => history.go(0));
    }
    
    componentWillUnmount() {
        super.componentWillUnmount();
        this.backListener();
    }

    renderMessageLines = () => this.props.message.map((line, index) => <div className="sub header" key={index}>{line}</div>);

    render() {
        return (
            <React.Fragment>
                <div className="error-screen-component ui container">
                    <div className={`ui ${this.props.statusCode ? "two" : "one"} column grid`}>
                        <div className="column">
                            <h2 className="ui red icon header">
                                <i className="times circle outline icon"></i>
                                <div className="content">Coś poszło nie tak</div>
                            </h2>
                        </div>
                        {this.props.statusCode ? (
                            <div className="column">
                                <h2 className="ui red header">
                                    <div className="ui huge red header">{this.props.statusCode}</div>
                                    <p>{this.props.statusText}</p>
                                </h2>
                            </div>
                        ) : null}
                    </div>
                    <div className="ui divider" />
                    <div className="ui large header">
                        <div className="content">
                            {this.props.statusCode ? (
                                <React.Fragment>
                                    Żądanie nie powiodło się z kodem błędu<br />{this.props.statusCode} ({this.props.statusText})
                                </React.Fragment>
                            ) : null}
                            {this.renderMessageLines()}
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default ErrorScreen;

export const Error404 = connect(null, { setError })(
    class Error404 extends React.Component {
        componentDidMount() { this.props.setError(404, "Not Found", [`Żądana strona "${history.location.pathname}" nie została odnaleziona`]); }
        render() { return <div />; }
    }
);